<section class="complete-section">

  <!-- Tab bar — only shown when both tabs have content -->
  <div class="editor-tab-bar" *ngIf="showTabs">
    <div [ngClass]="selectedTab === 'CONTENT' ? 'active-content-tab' : 'content-tab'"
      (click)="tabShift('CONTENT')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
      Content
    </div>
    <div [ngClass]="selectedTab === 'STYLES' ? 'active-content-tab' : 'content-tab'"
      (click)="tabShift('STYLES')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
      </svg>
      Styles
    </div>
  </div>

  <!-- ── CONTENT ──────────────────────────────────────────────── -->
  <div class="content" *ngIf="selectedTab === 'CONTENT'">

    <!-- ① Display -->
    <div class="li-section" *ngIf="data?.inputText?.length > 0">
      <p class="li-section-header">Display</p>
      <div class="li-toggle-list">
        <div class="li-toggle-row" *ngFor="let inputText of data?.inputText">
          <span class="li-label">{{ inputText?.label }}</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="inputText.isRTE"
            role="switch" [class.active]="inputText?.isRTE">
        </div>
      </div>
    </div>

    <!-- ② Text -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('inputText')">
      <p class="li-section-header">Text</p>
      <div class="li-field" *ngFor="let inputText of data?.inputText">
        <div class="li-field-header">
          <label class="li-field-label">{{ inputText?.label }}</label>
          <span class="li-regenerate" (click)="regerateContent(inputText)" *ngIf="inputText?.label != 'Step'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15"/>
            </svg>
          </span>
        </div>
        <input *ngIf="!inputText?.isRTE" type="text" class="li-input"
          [(ngModel)]="inputText.value" (ngModelChange)="onTextValueChange()"
          [placeholder]="inputText?.label">
        <app-simpo-text-editor *ngIf="inputText?.isRTE" [(value)]="inputText.value"
          [editable]="true" (valueChange)="onTextValueChange()"></app-simpo-text-editor>
      </div>
    </div>

    <!-- ③ Image -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('image') && (!data?.hasOwnProperty('icon') || content?.display?.showImage)">
      <p class="li-section-header">Image</p>
      <div>
        <app-image-editor [imageData]="data.image" [sectionId]="sectionId"
          [templatePage]="templatePage" [currentPageIndex]="currentPageIndex"
          [embedded]="true" [compact]="false"></app-image-editor>
      </div>
    </div>

    <!-- ④ Icon -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('icon') && (!data?.hasOwnProperty('image') || content?.display?.showIcon)">
      <p class="li-section-header">Icon</p>
      <div class="li-section-body">

        <!-- Hidden file input shared by both upload zone and Replace button -->
        <input type="file" hidden accept="image/svg+xml,image/png" #iconUpload (change)="uploadIcon($event)">

        <!-- Upload zone — shown when no icon -->
        <div class="upload-zone" *ngIf="!data.icon.url" (click)="iconUpload.click()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#9CA3AF" viewBox="0 0 24 24" width="36" height="36">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="1.5"/>
            <circle cx="8.5" cy="8.5" r="1.5" stroke-width="1.5"/>
            <polyline points="21 15 16 10 5 21" stroke-width="1.5"/>
          </svg>
          <p class="upload-label">Upload icon</p>
          <span class="upload-limit">SVG or PNG (black &amp; white only)</span>
        </div>

        <!-- Image card — shown when icon is set -->
        <div class="image-card" *ngIf="data.icon.url">
          <div class="image-thumb">
            <img [src]="data.icon.url" alt="icon">
          </div>
          <div class="image-actions">
            <button class="btn-replace" (click)="iconUpload.click()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15" height="15">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                  d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"/>
              </svg>
              Replace
            </button>
            <button class="btn-delete" (click)="deleteIcon()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15" height="15">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                  d="m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"/>
              </svg>
              Delete
            </button>
          </div>
        </div>

        <div class="li-prop-row mt-10">
          <span class="li-label">Icon Color</span>
          <input type="color" [(ngModel)]="data.icon.color" (ngModelChange)="emitIconChange()"
            class="li-color-dot">
        </div>

        <div class="li-prop-row mt-10">
          <span class="li-label">Show Background</span>
          <input class="toggle-input" type="checkbox" [(ngModel)]="data.icon.showBackground" role="switch"
            [class.active]="data.icon.showBackground" (ngModelChange)="emitIconChange()">
        </div>

        <ng-container *ngIf="data.icon.showBackground">
          <div class="seg-buttons mt-8">
            <div class="seg-left" (click)="data.icon.backgroundType = 'Solid'; emitIconChange()"
              [ngClass]="{'seg-selected': data.icon.backgroundType === 'Solid'}">Solid</div>
            <div class="seg-right" (click)="data.icon.backgroundType = 'Gradient'; emitIconChange()"
              [ngClass]="{'seg-selected': data.icon.backgroundType === 'Gradient'}">Gradient</div>
          </div>
          <div class="mt-8">
            <p class="li-field-label mb-2">Icon Background</p>
            <div class="color-row">
              <input type="color" [(ngModel)]="data.icon.backgroundColor" (ngModelChange)="emitIconChange()"
                class="icon-color-swatch">
              <input type="text" [(ngModel)]="data.icon.backgroundColor" disabled class="icon-color-text">
            </div>
          </div>
          <ng-container *ngIf="data.icon.backgroundType === 'Gradient'">
            <div class="mt-8">
              <p class="li-field-label mb-2">Secondary Color</p>
              <div class="color-row">
                <input type="color" [(ngModel)]="data.icon.secondaryColor" (ngModelChange)="emitIconChange()"
                  class="icon-color-swatch">
                <input type="text" [(ngModel)]="data.icon.secondaryColor" disabled class="icon-color-text">
              </div>
            </div>
            <div class="mt-8">
              <p class="li-field-label mb-2">Direction</p>
              <div class="seg-buttons">
                <div class="seg-left" (click)="data.icon.backgroundGradientDirection = 'RIGHT'; emitIconChange()"
                  [ngClass]="{'seg-selected': data.icon.backgroundGradientDirection === 'RIGHT'}">→ Right</div>
                <div class="seg-mid" (click)="data.icon.backgroundGradientDirection = 'DOWN'; emitIconChange()"
                  [ngClass]="{'seg-selected': data.icon.backgroundGradientDirection === 'DOWN'}">↓ Down</div>
                <div class="seg-right" (click)="data.icon.backgroundGradientDirection = 'DIAGONAL_RIGHT'; emitIconChange()"
                  [ngClass]="{'seg-selected': data.icon.backgroundGradientDirection === 'DIAGONAL_RIGHT'}">↘ Diagonal</div>
              </div>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>

    <!-- ⑤ Button -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('button')">
      <p class="li-section-header">Button</p>
      <div>
        <app-button-editor [buttonData]="data.button" [templatePage]="templatePage"
          [currentPageIndex]="currentPageIndex" [embedded]="true"></app-button-editor>
      </div>
    </div>

    <div class="li-section" *ngIf="buttonData && data?.hasOwnProperty('content')">
      <p class="li-section-header">Button</p>
      <div>
        <app-button-editor [buttonData]="data.content" [templatePage]="templatePage"
          [currentPageIndex]="currentPageIndex" [embedded]="true"></app-button-editor>
      </div>
    </div>

    <!-- Highlight -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('highlight')">
      <p class="li-section-header">Highlight</p>
      <div class="li-section-body">
        <div class="li-prop-row">
          <div>
            <span class="li-label" style="font-weight:500;">Featured tier</span>
            <p class="li-hint">Make this tier stand out to encourage customers to select it.</p>
          </div>
          <input class="toggle-input" type="checkbox" [(ngModel)]="data.highlight.highlighted" role="switch"
            [class.active]="data.highlight.highlighted">
        </div>
        <div class="li-field" *ngIf="data?.highlight?.highlighted" style="padding:0;margin-top:10px;">
          <label class="li-field-label">Label</label>
          <input type="text" class="li-input mt-6" [(ngModel)]="data.highlight.label">
        </div>
      </div>
    </div>

    <!-- What's included -->
    <div class="li-section" *ngIf="data?.hasOwnProperty('additionalData')">
      <p class="li-section-header">What's included</p>
      <div class="li-section-body">
        <div class="additional-list">
          <div class="additional-item" *ngFor="let item of data.additionalData; let i = index">
            <ng-container *ngIf="!item.edit">
              <span class="additional-item__text">{{item.content}}</span>
              <div class="additional-item__actions">
                <button class="item-action-btn" (click)="item.edit = true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="var(--primary-bg-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                  </svg>
                </button>
                <button class="item-action-btn item-action-btn--danger" (click)="deleteAdditionalCharge(i)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7" />
                    <path d="M10 11v6M14 11v6M4 7h16" />
                    <path d="M9 7V4c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1v3" />
                  </svg>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="item.edit">
              <input type="text" class="additional-item__input" [(ngModel)]="item.content">
              <button class="item-action-btn" (click)="item.edit = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="var(--primary-bg-color)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </button>
            </ng-container>
          </div>
        </div>
        <button class="add-item-btn mt-8" (click)="addingAdditionalData = true" *ngIf="!addingAdditionalData">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Add item
        </button>
        <div class="additional-item" *ngIf="addingAdditionalData">
          <input type="text" class="additional-item__input" [(ngModel)]="additionalContent"
            placeholder="Enter item text...">
          <div class="additional-item__actions">
            <button class="item-action-btn" (click)="addAdditionalData()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="var(--primary-bg-color)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </button>
            <button class="item-action-btn item-action-btn--danger" (click)="addingAdditionalData = false">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content (plain textarea) -->
    <div class="li-section" *ngIf="!buttonData && data?.hasOwnProperty('content')">
      <p class="li-section-header">Content</p>
      <div class="li-section-body">
        <textarea class="li-input" [(ngModel)]="data.content" rows="4" style="resize:vertical;"></textarea>
      </div>
    </div>

    <!-- Hotspots -->
    <div class="li-section" *ngIf="data?.hotspots">
      <p class="li-section-header">Hotspots</p>
      <div class="li-section-body">
        <ng-container *ngFor="let hotspot of data.hotspots; let i = index">
          <div class="hotspot-card">
            <div class="hotspot-card__header">
              <span>Hotspot <span class="hotspot-index">{{ i + 1 }}</span></span>
              <button class="item-action-btn item-action-btn--danger" (click)="removeHotspot(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m19 7-.8673 12.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224c-1.04928 0-1.92016-.8109-1.99492-1.8575L5 7" />
                  <path d="M10 11v6M14 11v6M4 7h16" />
                  <path d="M9 7V4c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1v3" />
                </svg>
              </button>
            </div>
            <label class="li-field-label mb-2">Title</label>
            <input class="li-input mb-8" [(ngModel)]="hotspot.title" type="text" placeholder="Hotspot title">
            <label class="li-field-label mb-2">Image URL</label>
            <input class="li-input mb-8" [(ngModel)]="hotspot.img" type="text" placeholder="https://...">
            <label class="li-field-label mb-2">Link Text</label>
            <input class="li-input mb-8" [(ngModel)]="hotspot.linkText" type="text" placeholder="Learn more">
            <label class="li-field-label mb-2">Link</label>
            <input class="li-input" [(ngModel)]="hotspot.link" type="text" placeholder="https://...">
          </div>
        </ng-container>
        <button (click)="addHotspot()" class="add-item-btn mt-8">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Add Hotspot
        </button>
      </div>
    </div>

  </div>

  <!-- ── STYLES ────────────────────────────────────────────────── -->
  <div *ngIf="selectedTab === 'STYLES'">

    <ng-container *ngIf="data?.hasOwnProperty('background')">
      <div class="li-section">
        <p class="li-section-header">Card Background</p>
        <div class="li-section-body">

          <p class="li-field-label mb-6">Type</p>
          <div class="seg-buttons">
            <div class="seg-left" [ngClass]="{'seg-selected': data.background.backgroundType === 'Solid'}"
              (click)="data.background.backgroundType = 'Solid'">Solid</div>
            <div class="seg-right" [ngClass]="{'seg-selected': data.background.backgroundType === 'Gradient'}"
              (click)="data.background.backgroundType = 'Gradient'">Gradient</div>
          </div>

          <p class="li-field-label mb-6 mt-12">Color</p>
          <div class="li-color-field">
            <input type="color" class="li-color-swatch" [(ngModel)]="data.background.color">
            <input type="text" class="li-color-input" [(ngModel)]="data.background.color">
          </div>

          <ng-container *ngIf="data.background.backgroundType === 'Gradient'">
            <p class="li-field-label mb-6 mt-12">Secondary Color</p>
            <div class="li-color-field">
              <input type="color" class="li-color-swatch" [(ngModel)]="data.background.secondaryColor">
              <input type="text" class="li-color-input" [(ngModel)]="data.background.secondaryColor">
            </div>

            <p class="li-field-label mb-6 mt-12">Direction</p>
            <div class="dir-buttons">
              <button class="dir-btn" title="Down"
                [class.dir-btn--active]="data?.background?.backgroundGradientDirection === 'DOWN'"
                (click)="data.background.backgroundGradientDirection = 'DOWN'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 14-7 7m0 0-7-7m7 7V3" />
                </svg>
              </button>
              <button class="dir-btn" title="Right"
                [class.dir-btn--active]="data?.background?.backgroundGradientDirection === 'RIGHT'"
                (click)="data.background.backgroundGradientDirection = 'RIGHT'">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14 5 7 7m0 0-7 7m7-7H3" />
                </svg>
              </button>
              <button class="dir-btn" title="Diagonal right"
                [class.dir-btn--active]="data?.background?.backgroundGradientDirection === 'DIAGONAL_RIGHT'"
                (click)="data.background.backgroundGradientDirection = 'DIAGONAL_RIGHT'">
                <svg style="transform: rotateZ(240deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 14-7 7m0 0-7-7m7 7V3" />
                </svg>
              </button>
              <button class="dir-btn" title="Diagonal left"
                [class.dir-btn--active]="data?.background?.backgroundGradientDirection === 'DIAGONAL_LEFT'"
                (click)="data.background.backgroundGradientDirection = 'DIAGONAL_LEFT'">
                <svg style="transform: rotateZ(135deg)" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="18" height="18">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 14-7 7m0 0-7-7m7 7V3" />
                </svg>
              </button>
            </div>
          </ng-container>

        </div>
      </div>
    </ng-container>

  </div>

  <div class="Footer" *ngIf="newItem && !buttonData">
    <button class="btn" (click)="addNewItem()">Add Data</button>
  </div>

</section>